import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useDriverStore = defineStore('driver', {
  state: () => ({
    driver:[],
    drivers: [],
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    filters: {
      driverId: '',
      name:'',
      plate: '',
      license: '',
      mobile: '',
      abn: '',
      paymentMethod: '',
      lastTerminalUsed:'',
      includeBadDrivers: false,
      badDriversOnly: false,
      subgroup: '',
      last_updated_from: '',
      last_updated_to: '',
      sort_by:'created_at',
      order:'desc',
    },
  }),
  actions: {
    async fetchDrivers() {
      const params = {
        per_page: this.itemsPerPage,
        page: this.currentPage,
        driver_id: this.filters.driverId,
        driver_name:this.filters.name,
        plate: this.filters.plate,
        license: this.filters.license,
        mobile: this.filters.mobile,
        abn: this.filters.abn,
        last_terminal_used: this.filters.lastTerminalUsed,
        payment_method: this.filters.paymentMethod,
        include_bad_drivers: this.filters.includeBadDrivers ? 1 : 0,
        bad_drivers_only: this.filters.badDriversOnly ? 1 : 0,
        subgroup: this.filters.subgroup,
        last_updated_from: this.filters.last_updated_from,
        last_updated_to: this.filters.last_updated_to,
        sort_by: this.filters.sort_by,
        order: this.filters.order
      };
    
      try {
        const response = await useHttp().post('/api/admin/driver/list', params);
        if (statusCheck(response.data)) {
          this.drivers = response.data.drivers;
          this.totalEntries = response.data.total;
        } else {
          console.error('Failed to fetch drivers');
        }
      } catch (error) {
        console.error('Error fetching drivers:', error);
      }
    },
    
    setFilters(newFilters) {
      this.filters = { ...newFilters };
    },
    
    resetFilters() {
      this.filters = {
        name: '',
        driverId: '',
        plate: '',
        license: '',
        mobile: '',
        lastTerminalUsed: '',
        paymentMethod: '',
        abn: '',
        subgroup: '',
        last_updated_from: '',
        last_updated_to: '',
        includeBadDrivers: false,
        badDriversOnly: false,
      };
    },
    async fetchDriverById(driverId){
        try {
        const response = await useHttp().get(`api/admin/driver/info?id=${driverId}`);
        if (statusCheck(response.data)) {
            this.driver = response.data.result;
          } else {
            console.error('Failed to fetch drivers');
          }
        } catch (error) {
          console.error('Error fetching driver:', error);
        }
    },
    async fetchDriverByDriverId(driverId){
      try {
      const response = await useHttp().get(`api/admin/driver/info?driver_id=${driverId}`);
      if (statusCheck(response.data)) {
          return response.data.result;
        } else {
          console.error('Failed to fetch drivers');
        }
      } catch (error) {
        console.error('Error fetching driver:', error);
      }
  },
    async changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        await this.fetchDrivers();
      }
    },
    async addDriver(driverData) {
        try {
          const response = await useHttp().post('/api/admin/driver/create', driverData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          if (statusCheck(response.data)) {
            await this.fetchDrivers(); // 新增成功後重新抓取司機列表
            Swal.fire({
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        } catch (error) {
          console.error('Error adding driver:', error);
        }
      },
      async editDriver(driverData){
        try{
            const response = await useHttp().post('/api/admin/driver/update', driverData,{
                headers:{
                    'Content-Type': 'multipart/form-data',
              },
            });
            console.log(response);
            if (statusCheck(response.data)) {
                await this.fetchDrivers(); // 新增成功後重新抓取司機列表
                Swal.fire({
                  icon: 'success',
                  title: response.data.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
            }
        }catch{
            console.error('Error edit driver:', error);
        }
      },
      async GetPayIdAccountName(pay_id ,pay_id_type){ {
        try {

          const payload = {
            pay_id: pay_id,  
            pay_id_type: pay_id_type 
          };
      
          const response = await useHttp().post('/api/admin/driver/account_name', payload);
          if (statusCheck(response.data)) {
            return response.data.account_name;
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Account name not found. Please try again.',
            })
          }
        } catch (error) {
          console.error('Error fetching history:', error);
          throw error;
        }
      }
    },
    async sendVerificationEmail(driverId) {
      try {
        const response = await useHttp().post('/api/admin/driver/send_verify_email', {
          driver_id: driverId,
        });
        if (statusCheck(response.data)) {
          return response.data;
        }
        return null;
      } catch (error) {
        console.error('Error sending verification email:', error);
        throw error;
      }
    },
      
  },
  getters: {
    paginatedData(state) {
      return state.drivers;
    },
    totalPages(state) {
      return Math.ceil(state.totalEntries / state.itemsPerPage);
    },
  },
});
